import { connect } from "react-redux";
import * as React from "react";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { ConversationInterface } from "../../../Entity/Entities/Conversation/ConversationInterface";
import Button from '@material-ui/core/Button';
import TextField from "../../Partials/Material/TextField";
import PersonLookup from "../../Partials/Lookup/PersonLookup";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Switch from '@material-ui/core/Switch';
import Card from '@material-ui/core/Card';
import { Event } from "../../../Entity/Entities/Event/Event";
// import { PageTransition } from "../../Partials/Spinner/PageTransition";
import Message from "./Message";
import * as uuidV4 from "uuid/v4";
import { Attachment } from "../../Partials/Attachment/Attachment";

interface StateInterface {
  message: string;
	contactId: number;
	mobilePhone: string;
	mobilePhoneWasManuallyChanged: boolean;
	email: string;
	emailWasManullyChanged: boolean;
	usedSmsChannel: boolean;
	usedEmailChannel: boolean;
	contactWasManullyChanged: boolean;
	requestError: boolean;
	amazonFolderName: string;
	attachments: any[];
	isEmailValid: boolean;
}

class Conversation extends Component {
	public contactLookup;

  public state: StateInterface = {
    message: "",
		contactId: this.props.conversation?.contactId || null,
		mobilePhone: "",
		email: "",
		usedSmsChannel: false,
		usedEmailChannel: true,
		contactWasManullyChanged: false,
		mobilePhoneWasManuallyChanged: false,
		emailWasManullyChanged: false,
		requestError: false,
		amazonFolderName: this.props.conversation?.amazonFolderName || uuidV4(),
		attachments: [],
		isEmailValid: true,
  };

  constructor(public props) {
    super(props);

		this.contactLookup = React.createRef();
  }

	public componentWillMount() {
		if (this.props.conversation) {
			this.props.dispatch({
				type: Constants.GLOBAL_CONVERSATION_READ_UPDATE_START,
				payload: {
					conversationId: this.props.conversation?.id
				}
			});

			this.setState({
				attachments: this.props.conversation.attachments
			});
		}
	}

	public componentWillReceiveProps(nextProps) {
		if (nextProps.conversation) {
			const conversationMessages = document.getElementById(`conversation-${nextProps?.conversation?.id}-messages`);
			this.scrollToBottom(conversationMessages);

			// logic to select channels for existing conversation
			// TODO fix hardcoded values
			if (nextProps.conversation?.notificationChannels?.some(channel => channel?.id === 1)) {
				this.setState({
					usedEmailChannel: true
				});
			} else {
				this.setState({
					usedEmailChannel: false
				});
			}

			if (nextProps.conversation?.notificationChannels?.some(channel => channel?.id === 2)) {
				this.setState({
					usedSmsChannel: true
				});
			} else {
				this.setState({
					usedSmsChannel: false
				});
			}

			this.setState({
				attachments: nextProps.conversation.attachments
			});
		} else {
			// logic to preselect contact for new conversation
			// if (nextProps.entity instanceof Event) {
			// 	if (!!nextProps.entity?.property && !this.state.contactWasManullyChanged) {
			// 		const generalContact = nextProps.entity?.property?.company?.generalContact;
					
			// 		return this.setState({
			// 			contactId: generalContact?.id,
			// 			mobilePhone: generalContact?.phone1,
			// 			email: generalContact?.email
			// 		})
			// 	}
		
			// 	if (!!nextProps.entity?.unit && !this.state.contactId) {
			// 		const generalContact = nextProps.entity?.unit?.property?.company?.generalContact;

			// 		return this.setState({
			// 			contactId: generalContact?.id,
			// 			mobilePhone: generalContact?.phone1,
			// 			email: generalContact?.email
			// 		})
			// 	}
			// }
		}
	}

	public selectPerson = (person: PersonInterface): void => {
    this.setState({
      contactId: person?.id,
			mobilePhone: person?.phone1,
			email: person?.email,
			contactWasManullyChanged: true
    });
  }

  public clearPerson = (): void => {
    this.setState({
      contactId: null,
			mobilePhone: "",
			email: "",
			contactWasManullyChanged: true
    });
  }

	public changeUsedSmsChannel = () => {
    this.setState({
      usedSmsChannel: !this.state.usedSmsChannel
    }, () => {
			if (this.props.conversation) {
				this.updateConversationNotificationChannels();
			}
		});
  }

	public changeUsedEmailChannel = () => {
    this.setState({
      usedEmailChannel: !this.state.usedEmailChannel,
	  isEmailValid: true,
    }, () => {
			if (this.props.conversation) {
				this.updateConversationNotificationChannels();
			}
		});
  }

  public createConversation = (): any => {
    const conversation: any = {
			notificationChannels: [],
			contactId: this.state.contactId,
			amazonFolderName: this.state.amazonFolderName
		};

		if (this.props.entity instanceof Event) {
      conversation.eventId = this.props.entity?.id;
    }

		if (this.state.usedEmailChannel) {
			conversation?.notificationChannels?.push(1); // TODO fix hardcoded value
		}

		if (this.state.usedSmsChannel) {
			conversation?.notificationChannels?.push(2); // TODO fix hardcoded value
		}

		return this.saving(() => {
			this.props.dispatch({
				type: Constants.GLOBAL_CONVERSATION_CREATE_START,
				payload: {
					conversation: {...conversation}
				},
				onSuccess: (conversation: ConversationInterface) => {
					this.contactLookup?.current?.refs?.instance?.onClear(false);

					this.setState({
						contactId: null,
						mobilePhone: "",
						email: "",
						usedSmsChannel: false,
						usedEmailChannel: true,
					}, this.createMessage.bind(this, conversation));
				},
				onError: () => {
					return this.setState({
						hasModifiedData: true,
						requestError: true,
						isSaving: false
					});
				}
			});
		});
  }

	public updateConversationNotificationChannels = (): any => {
    const conversation: any = {
			conversationId: this.props.conversation?.id,
			notificationChannels: []
		};

		if (this.state.usedEmailChannel) {
			conversation?.notificationChannels?.push(1); // TODO fix hardcoded value
		}

		if (this.state.usedSmsChannel) {
			conversation?.notificationChannels?.push(2); // TODO fix hardcoded value
		}

		return this.saving(() => {
			this.props.dispatch({
				type: Constants.GLOBAL_CONVERSATION_NOTIFICATION_CHANNELS_UPDATE_START,
				payload: {
					conversation: {...conversation}
				},
				onSuccess: (_conversation: ConversationInterface) => {
					
				},
				onError: () => {
					return this.setState({
						hasModifiedData: true,
						requestError: true,
						isSaving: false
					});
				}
			});
		});
  }

	public createMessage = (conversation: ConversationInterface): any => {
		// if (this.state.usedSmsChannel) {
		// 	this.checkPhoneNumber();
		// }

    const message: any = {
			conversationId: conversation?.id,
			message: this.state.message
		};

		return this.saving(() => {
			this.props.dispatch({
				type: Constants.GLOBAL_MESSAGE_CREATE_START,
				payload: {
					message: {...message}
				},
				onSuccess: (conversation: ConversationInterface) => {
					this.setState({
						message: ""
					}, () => {
						const conversationMessages = document.getElementById(`conversation-${conversation?.id}-messages`);
						this.scrollToBottom(conversationMessages);
					})
				},
				onError: () => {
					return this.setState({
						hasModifiedData: true,
						requestError: true,
						isSaving: false
					});
				}
			});
		});
  }

	public checkPhoneNumber = (callback?): any => {
		return this.saving(() => {
			this.props.dispatch({
				type: Constants.CHECK_PHONE_NUMBER_START,
				payload: {
					phoneNumber: this.state.mobilePhone
				},
				onSuccess: () => {
					if (typeof callback === "function") {
						callback();
					}
				},
				onError: () => {
					return this.setState({
						hasModifiedData: true,
						requestError: true,
						isSaving: false
					});
				}
			});
		});
  }

	public changeConversationStatus = () => {
		const conversation: any = {
			conversationId: this.props.conversation?.id,
			// TODO fix hardcoded value
			statusId: this.props.conversation?.statusId === 1 ? 2 : 1
		};

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_CONVERSATION_STATUS_UPDATE_START,
        payload: {
					conversation: {...conversation}
        },
        onSuccess: (_conversation: ConversationInterface) => {
					
        },
        onError: () => {
          this.setState({
            hasModifiedData: true,
						requestError: true,
						isSaving: false
          });
        }
      });
    });
  }

	public scrollToBottom(element) {
		setTimeout(() => {
			return element && element.scroll({ top: element.scrollHeight });
		}, 100);	
	}

	public personUpdate(callback?) {
		// do not need update persons phone/email if they were not changes
		if (!this.state.mobilePhoneWasManuallyChanged && !this.state.emailWasManullyChanged && typeof callback === "function") {
			return callback();
		}

    this.saving(() => {
      this.props.dispatch({
        type: Constants.PAGE_CONTACT_PERSON_UPDATE_START,
        payload: {
          id: this.state.contactId,
          person: {
            email: this.state.email,
            phone1: this.state.mobilePhone
          },
					hideSnackbar: true
        },
        onSuccess: () => {
          if (typeof callback === "function") {
						callback();
					}
        },
        onError: () => {
          this.setState({
            hasModifiedData: true,
						requestError: true,
						isSaving: false
          });
        }
      });
    });
  }

	public startProcess = () => {
		this.props.dispatch({
			type: Constants.GLOBAL_CONVERSATION_CREATE_CLEAR
		});

		if (this.props.conversation) {
			return this.personUpdate(this.createMessage.bind(this, this.props.conversation));
		} else {
			if (this.state.message) {
				if (this.state.contactId) {
					return this.personUpdate(this.createConversation);
				} else {
					return this.createConversation();
				}
			} else {
				this.props.dispatch({
					type: Constants.GLOBAL_MESSAGE_CREATE_FAILURE,
					payload: {
						err: {
							errorId: "be_ajv_not_validated",
							fields: ["message"],
							isAuthenticationIssue: false,
							isValidationError: true,
							message: "This field is not valid",
							translatedMessage: "This field is not valid"
						}
					}
				})

				this.setState({
					requestError: true
				});
			}
		}
	}

  public render() {
		const conversationContact: PersonInterface = this.props.app.persons.find(person => person.id === this.state.contactId);

    return (
			<div className="component" style={{marginBottom: this.props.withoutBottomMargin ? "0" : "20px", backgroundColor: "white"}}>
        {/* {
          this.state.isSaving && (
            <div className="component-spinner-wrapper">
              <CircularProgress />
            </div>
          )
        } */}
        <Card className="card">
          <div className="label-container"
            style={{
              display: "flex",
              justifyContent: "space-between"
            }}
          >
						<h3 className="card-title">
							{conversationContact ? this.trans("label-conversation-with", {person: conversationContact?.displayName}) :
							this.props.conversation ? this.trans("label-conversation") : this.trans("label-new-conversation")}
						</h3>
          </div>
					<div className="conversation">
						<div className="left-section">
							<div id={`conversation-${this.props.conversation?.id}-messages`} className="messages">
								{
									this.props.conversation?.messages?.map(message => {
										const sender = this.props.app.persons.find(person => person.id === message?.senderId);
										const isUser = sender?.isAdmin() || sender?.isUser();

										return (
											<Message 
												{...this.props}
												key={`message-${message?.id}`}
												isOutgoing={isUser}
												sender={sender}
												message={message}
											/>
										);
									})
								}
							</div>
							<div className="new-message">
								<TextField
									autoComplete="off"
									className="message-textfield"
									type="text"
									multiline
									variant="filled"
									rowsMax="10"
									rows="1"
									label={this.trans("message")}
									value={this.state.message}
									onChange={e => this.setState({message: e.target.value, requestError: false})}
									error={this.state.requestError && !this.state.message && !!this.getErrorFor("message")}
									helperText={this.state.requestError && !this.state.message && this.getErrorFor("message")}
									disabled={!this.state.contactId}
								/>

								<Button
									color="primary"
									variant="outlined"
									onClick={() => this.setState({requestError: false}, this.startProcess)}
								>
									{this.trans("button-send")}
								</Button>
							</div>
						</div>
						<div className="right-section">
							{
								this.props.conversation && (
									<div className="switcher-wrapper">
										<FormControlLabel
											control={
												<Switch
													checked={this.props.conversation?.statusId === 2} // TODO fix hardcoded value
													onChange={this.changeConversationStatus}
													color="primary"
												/>
												}
											label={this.trans("status-closed")}
										/>
									</div>
								)
							}

							<PersonLookup
								{...this.props}
								autoSelectId={this.state.contactId}
								isInlineBlock={true}
								width="100%"
								containerWidth="100%"
								// ref="PersonLookup"
								ref={this.contactLookup}
								floatingLabelText={this.trans("label-conversation-with", {person: ""})}
								labelText={this.trans("label-conversation-with", {person: ""})}
								onSelect={this.selectPerson}
								onClear={this.clearPerson}
								disableEntityCreation={true}
								hideClickThroughLink={true}
								noResultText={this.trans("no-contacts-to-list")}
								error={this.state.requestError && this.getErrorFor("contactId")}
								disabled={this.props.conversation}
							/>

							{
								this.state.contactId && (
									<React.Fragment>
										<FormControlLabel
											style={{marginBottom: "-20px"}}
											control={
												<Checkbox
													checked={this.state.usedEmailChannel}
													onChange={this.changeUsedEmailChannel}
													color="primary"
													disabled
												/>
											}
											label={this.trans("label-email-notification")}
										/>
										
										{
											this.state.usedEmailChannel && (
												<TextField
													autoComplete="off"
													className="form-element full-size"
													type="text"
													label={this.trans("label-email")}
													value={this.state.email}
													onChange={e => this.setState({email: e.target.value, emailWasManullyChanged: true})}
													variant="standard"
													error={this.state.requestError && !!this.getErrorFor("email")}
													helperText={this.state.requestError && this.getErrorFor("email")}
													onBlur={e => {
														if (e.target.value.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
															this.setState({
																email: e.target.value, 
																emailWasManullyChanged: true,
																isEmailValid: true,
															}, () => {
																this.props.dispatch({
																	type: Constants.SNACKBAR_ADD_MESSAGE,
																	payload: {
																	  message: this.trans("email-was-saved"),
																	  type: "success"
																	}
																});
																return;
															})
														} else {
															this.setState({
																isEmailValid: false,
															})
															e.target.focus()
														}
													}}
												/>
											)
										}

										{!this.state.isEmailValid && this.state.usedEmailChannel && <div className="component-error-text">{this.trans("be_ajv_not_validated")}</div>}

										{/* <FormControlLabel
											style={{marginBottom: "-20px"}}
											control={
												<Checkbox
													checked={this.state.usedSmsChannel}
													onChange={this.changeUsedSmsChannel}
													color="primary"
												/>
											}
											label={this.trans("label-sms-notification")}
										/>

										{
											this.state.usedSmsChannel && (
												<TextField
													autoComplete="off"
													className="form-element full-size"
													type="text"
													label={this.trans("label-mob-number")}
													value={this.state.mobilePhone}
													onChange={e => this.setState({mobilePhone: e.target.value, mobilePhoneWasManuallyChanged: true})}
													variant="standard"
													error={this.state.requestError && (!!this.getErrorFor("mobilePhone") || !!this.getErrorFor("phoneNumber"))}
													helperText={this.state.requestError && (this.getErrorFor("mobilePhone") ? this.getErrorFor("mobilePhone") : this.getErrorFor("phoneNumber") ? this.getErrorFor("phoneNumber") : "")}
												/>
											)
										} */}
									</React.Fragment>
								)
							}
						</div>
					</div>
        </Card>
				
				<div style={{padding: "10px"}}>
					<Attachment
						{...this.props}
						entity={this.props.conversation || null}
						typeOfComponent="shared"
						title={this.trans("attachments-for-conversation")}
						relation="conversationId"
						onAmazonFolderNameGeneration={!this.state.amazonFolderName ?
							this.sync.bind(this, this.syncronizers.VALUE, "amazonFolderName") : null}
						amazonFolderName={!!this.state.amazonFolderName ? this.state.amazonFolderName : null}
						attachments={this.state.attachments}
						updateParentState={attachments => this.setState({attachments: attachments})}
						conversationView={true}
					/>
				</div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    events: state.events,
    tasks: state.tasks,
    component: state.conversation,
    globalTypes: state.globalTypes,
    properties: state.properties,
    units: state.units
  };
};

export default connect(mapStateToProps)(
  Conversation
);
